import paginaweb from "./paginaweb/paginaweb"
import micrositioweb from "./micrositioweb/micrositioweb"
import intranet from "./intranet/intranet"

const sicpo = {
    paginaweb: paginaweb,
    micrositioweb:micrositioweb,
    intranet: intranet
}

export default sicpo;


//////////////////
// WEBPACK FOOTER
// ./static/js/api/SICPO/sistema/sicpo.js
// module id = null
// module chunks = 